import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '@/shared/components/Input';
import { Textarea } from '@/shared/components/Textarea';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useCreateBlogPost, useUpdateBlogPost } from '../hooks/useBlogPosts';
export function BlogPostForm({ onSuccess, defaultValues, id }) {
    const [serverError, setServerError] = useState('');
    const isEdit = !!id;
    const createMutation = useCreateBlogPost();
    const updateMutation = useUpdateBlogPost(id ?? '');
    const isPending = createMutation.isPending || updateMutation.isPending;
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: { is_published: false, ...defaultValues },
    });
    function onSubmit(values) {
        setServerError('');
        // Drop empty optional fields so the URL validator doesn't reject "".
        const payload = {
            title: values.title,
            content: values.content,
            is_published: values.is_published,
            ...(values.excerpt ? { excerpt: values.excerpt } : {}),
            ...(values.cover_image_url ? { cover_image_url: values.cover_image_url } : {}),
        };
        const handler = isEdit ? updateMutation : createMutation;
        handler.mutate(payload, {
            onSuccess: () => onSuccess(),
            onError: (err) => {
                setServerError(err instanceof ApiError ? err.message : 'Ha ocurrido un error.');
            },
        });
    }
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Input, { label: "T\u00EDtulo", error: errors.title?.message, ...register('title', { required: 'El título es obligatorio' }) }), _jsx(Textarea, { label: "Extracto (opcional)", rows: 2, ...register('excerpt') }), _jsx(Textarea, { label: "Contenido", rows: 8, error: errors.content?.message, ...register('content', { required: 'El contenido es obligatorio' }) }), _jsx(Input, { label: "URL de imagen de portada (opcional)", type: "url", ...register('cover_image_url') }), _jsxs("label", { className: "flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300", children: [_jsx("input", { type: "checkbox", className: "h-4 w-4 rounded border-gray-300", ...register('is_published') }), "Publicar art\u00EDculo"] }), serverError && (_jsx("p", { role: "alert", className: "text-sm text-red-600 dark:text-red-400", children: serverError })), _jsx(Button, { type: "submit", loading: isPending, className: "w-full", children: isEdit ? 'Guardar cambios' : 'Crear artículo' })] }));
}
//# sourceMappingURL=BlogPostForm.js.map